var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Company",
            "tabActive": "Vision",
            "bg": "/images/sub/visual/sv-company.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h3', {
    staticClass: "tit tit--lg"
  }, [_vm._v("Vision")])]), _c('div', {
    staticClass: "w-100",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('v-img', {
    staticClass: "d-none d-md-block ma-auto",
    attrs: {
      "contain": "",
      "max-width": "1080",
      "src": "/images/sub/company/vision-img.png"
    }
  }), _c('v-img', {
    staticClass: "d-block d-md-none ma-auto",
    attrs: {
      "contain": "",
      "max-width": "672",
      "src": "/images/sub/company/vision-img-mo.png"
    }
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }